import { SxProps, Theme } from '@mui/material';

const compactButtonStyles = {
  fontSize: '0.75rem',
  lineHeight: 1.25,
  minHeight: 24,
  padding: '2px 8px',
};

export const toolbarContainerStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 0',
  backgroundColor: 'background.paper',
  borderBottom: '1px solid',
  borderColor: 'divider',
  '& .MuiButton-root': compactButtonStyles,
  '& .MuiButtonGroup-grouped': {
    minWidth: 28,
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1rem',
  },
};

export const navigationContainerStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
};

export const actionsContainerStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
};

export const labelStyles: SxProps<Theme> = {
  fontWeight: 500,
  fontSize: '0.875rem',
  ml: 1,
};

export const dateButtonStyles: SxProps<Theme> = {
  fontWeight: 500,
  fontSize: '0.875rem',
  ml: 1,
  textTransform: 'none',
  color: 'text.primary',
  minHeight: 24,
  padding: '2px 8px',
};

export const buttonStyles: SxProps<Theme> = {
  textTransform: 'none',
  ...compactButtonStyles,
};

export const viewButtonStyles: SxProps<Theme> = {
  textTransform: 'capitalize',
  ...compactButtonStyles,
};

/**
 * Workboard calendar view toggle (month / week) — dark mode only.
 * Selection reads via background fill + text weight, not a colored border — a bright
 * primary-colored border here read as a harsh focus-ring glow rather than a selected state,
 * and matches how selection is communicated elsewhere in dark mode (tertiary nav tabs, menu
 * items): background tint + text emphasis, same border weight for selected/unselected so
 * adjacent buttons in the group don't visually shift.
 */
export const getViewButtonDarkSx = (theme: Theme, selected: boolean): SxProps<Theme> => ({
  textTransform: 'capitalize',
  ...compactButtonStyles,
  bgcolor: selected ? theme.palette.action.selected : 'transparent',
  border: `1px solid ${theme.palette.divider}`,
  color: selected ? theme.palette.text.primary : theme.palette.text.secondary,
  fontWeight: selected ? 600 : 400,
  '&:hover': {
    bgcolor: selected ? theme.palette.action.selected : theme.palette.action.hover,
    border: `1px solid ${theme.palette.divider}`,
  },
});
